import { Trash2 } from 'lucide-react'
import { useTalkT } from './useTalkT'
import { HelpZettelStatus } from '@/components/help/HelpZettelStatus'
import { ROLE_LABELS, type Role } from '@/types/role'
import type { HelpZettel } from '@/types/help'
import { playTalkUrl } from './helpAudio'
import { formatTalkDuration, isTranscriptPending } from './talkFormat'
import { TranscriptRetryButton } from './TranscriptRetryButton'
import { useLocalPlayUrl } from './useLocalPlayUrl'

export function ListZettelCard({
  z,
  onOpen,
  onDelete,
  light = false,
}: {
  z: HelpZettel
  onOpen: () => void
  onDelete: () => void
  light?: boolean
}) {
  const t = useTalkT()
  const url = useLocalPlayUrl(z.opener_id, Boolean(z.has_audio && z.opener_id))
  const pending = isTranscriptPending(z.transcript_pending, z.opener_preview, z.has_audio)
  const preview = pending ? t('talk_transcript_pending') : z.opener_preview
  return (
    <div className={`talk-list-card ${light ? 'help-pair' : 'talk-pair'}`}>
      <div className="talk-list-main-wrap">
        <button type="button" className="talk-list-main" onClick={onOpen}>
          <div className="flex justify-between gap-2">
            <span className="role">{ROLE_LABELS[z.sender_role as Role] ?? z.sender_role}</span>
            <HelpZettelStatus status={z.status} light={light} />
          </div>
          <div className={light ? 'text-xs text-gray-600 line-clamp-2' : 'text-sm text-slate-300 line-clamp-2'}>
            {preview}
          </div>
        </button>
        <TranscriptRetryButton conversationId={z.conversation_id} zettelId={z.id} pending={pending} />
      </div>
      <div className="talk-card-actions">
        {url && (
          <button type="button" className="talk-play" aria-label={t('talk_play')} onClick={() => playTalkUrl(z.opener_id || z.id, url)}>
            <i>▶</i>
            {formatTalkDuration(z.audio_duration_ms)}
          </button>
        )}
        <button type="button" className="talk-icon-btn talk-trash-btn" aria-label={t('delete')} onClick={onDelete}>
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}
